import React, { Component } from 'react';
import { Elements, StripeProvider } from 'react-stripe-elements';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

import BillingForm from '../components/BillingForm';
import PurchaseSummary from '../components/PurchaseSummary';
import Loader from '../components/Loader';
import subscribeUser from '../services/billing/subscribeUser';
import createUser from '../services/user/createUser';
import config from '../config';
import createTeam from '../services/team/createTeam';

const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 10,
    paddingBottom: 10,
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 500,
  }),
  root: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 30,
    maxWidth: 650,
  },
});

class Checkout extends Component {
  state = {
    name: null,
    line1: '',
    line2: '',
    city: '',
    state: '',
    isProcessing: false,
    isSettingAccount: false,
    isCardComplete: false,
    isPayButtonDisabled: false,
  };

  handleCardChange = event => {
    this.setState({
      isCardComplete: event.complete,
    });
  };

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  handleSubmit = async (event, stripe) => {
    event.preventDefault();
    const tokenData = createTokenData({
      ...this.state,
      name: this.props.location.state.name,
    });
    const isUserDataVerified = verifyUserData(this.props.location.state);
    this.setState({
      isPayButtonDisabled: true,
    });
    try {
      if (stripe && isUserDataVerified) {
        const { token, error } = await stripe.createToken(tokenData);
        if (error) {
          alert(`${error.message}, ${error}, 1st Please contact support.`);
          // stop displaying processing payment
          //redirect to home page
        } else if (token) {
          this.setState({
            isProcessing: true,
          });
          const newCustomerId = await subscribeUser({
            ...token,
            ...this.props.location.state,
          });
          this.setState({
            isProcessing: false,
            isSettingAccount: true,
          });
          const newUser = await createUser({
            ...token,
            ...this.props.location.state,
            userType: 'customer',
            customerId: newCustomerId,
          });
          const newTeam = await createTeam({
            ...this.props.location.state,
            customerId: newCustomerId,
          });
          this.props.history.push('/home/new-signrider', {
            ...newUser,
            ...newTeam,
          });
        }
      } else {
        alert('An error occured, please contact support');
      }
    } catch (error) {
      this.setState({ isProcessing: false, isSettingAccount: false });
      alert('An error occured, please contact support');
      // redirect to support page
    }
  };

  render() {
    const { classes } = this.props;
    const {
      isProcessing,
      isSettingAccount,
      isPayButtonDisabled,
      line1,
      line2,
      city,
      state,
      name,
    } = this.state;
    const { plan } = this.props.location.state;
    const formProps = {
      handleChange: this.handleChange,
      handleCardFieldChange: this.handleCardChange,
      handleSubmit: this.handleSubmit,
      isPayButtonDisabled,
      ...this.state,
      name: name === null ? this.props.location.state.name : name,
      line1,
      line2,
      city,
      state,
    };
    if (isProcessing) {
      return <Loader loaderText={'Processing payment...'} />;
    } else if (isSettingAccount) {
      return <Loader loaderText={'Setting up account...'} />;
    } else {
      return (
        <div className={classes.root}>
          <Grid
            className={classes.grid}
            container
            spacing={24}
            justify="center"
            direction="row"
          >
            <Grid item xs={12} md={7} lg={7}>
              <Paper className={classes.paper} elevation={4}>
                <StripeProvider apiKey={config.STRIPE_KEY}>
                  <Elements>
                    <BillingForm {...formProps} />
                  </Elements>
                </StripeProvider>
              </Paper>
            </Grid>
            <Grid item xs={12} md={5} lg={5}>
              <PurchaseSummary summary={plan} />
            </Grid>
          </Grid>
        </div>
      );
    }
  }
}

const createTokenData = state => {
  const tokenData = {
    name: state.name,
    address_line1: state.line1,
    address_line2: state.line2,
    address_city: state.city,
    address_state: state.state,
    address_country: 'US',
  };
  return tokenData;
};

const verifyUserData = userData => {
  const { name, email, phoneNumber, plan } = userData;
  return email && name && phoneNumber && plan.id;
};

export default withRouter(withStyles(styles)(Checkout));



// WEBPACK FOOTER //
// ./src/containers/Checkout.js